import "../../styles/ProductCard.css";
import "./ProductCardNew.css";
import { Heart, Eye, ShoppingBasket, Star, Gift, Truck, ShoppingCart } from "lucide-react";
import { addWishlist } from "../../services/wishlistService";
import { useAuth } from "../../context/AuthContext";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import CartQuantityControl from "./CartQuantityControl";

import BasketControl from "./BasketControl";
import FooterQuantity from "./FooterQuantity";

import GiftModal from "../product/GiftModal/GiftModal";
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import CartControl from "./CartControl";


export const ProductCard = ({ product }) => {

  // console.log(product);
  //const [isWishlisted, setIsWishlisted] = useState(false);
  const { user } = useAuth();

  // const handleAddWishlist = async () => {
  //   const item = {
  //     userId: user.id,
  //     productId: product.id,
  //   };

  //   // console.log("Items:",item);

  //   await addWishlist(item);
  //   setIsWishlisted(true);
  //   toast.success("Added to wishlist");
  // };


  // const discount =
  //   product.old_price && product.price
  //     ? Math.round(
  //       ((product.old_price - product.price) / product.old_price) * 100,
  //     )
  //     : 0;

      const discount = Number(
    product.discountPercent || 0
);

  const navigate = useNavigate();

  const {
    cart,
    addToCart,
    getCartItem,
  } = useCart();

  const [showGiftModal, setShowGiftModal] = useState(false);

  const [selectedGift, setSelectedGift] = useState(null);

  const cartItem =
    product.variationCount === 1
      ? getCartItem(product.id, product.variationId)
      : cart.find(item => item.id === product.id);

  const inCart = !!cartItem;

  const hasGift = product.hasGift;

  const addCurrentProduct = (gift = null) => {

    addToCart({
      ...product,
      qty: 1,
      selectedGift: gift,
      selectedVariation: {
        variationId: product.variationId,
        quantity: product.stock,
        isExpired: false,

      },

    });

  };

  


  return (

    <div className="product-card">
      {discount > 0 ? <span className="discount-badge">%{discount}</span> : <></>}
      {product.hasGift ? <span className="gift-badge"><Gift className="gift-icon" size={20} /></span> : <></>}
      {product.freeShipping ? <span className="shipping-badge"><Truck className="shipping-icon" size={22} /></span> : <></>}
      {product.attributeCount > 1 ? <span className="variation-badge"> {product.attributeCount} طعم</span> : <></>}

      <div
        className={`product-image ${!product.inStock
          ? "product-out-of-stock"
          : ""
          }`}
      >
 <Link to={`/product/${product.slug}`}>
        <img
          src={product.image}
          alt={product.name}
           loading="lazy"
        />
         </Link>

         
       

        {!product.inStock && (

          <div className="stock-overlay">
            <span>
              ناموجود
            </span>
          </div>

        )}

      </div>

      <div className="product-content">
        <Link to={`/product/${product.slug}`}>
          <h3 className="product-title">{product.name}</h3>
        </Link>


        <Link to={`/products?brand=${product.brand_id}`}>
          <h4 className="product-brand">{product.brand}</h4>
        </Link>

        <div
          className={`product-price-item ${!product.isDiscounted ? "no-discount" : ""
            }`}
        >
          <div className="price-lowest">
            <span className="price-lowest-list">
              {Number(product.lowestSalePrice).toLocaleString()}
              <span className="unit"> تومان</span>
            </span>
          </div>

          <div className="price-old">
            {product.isDiscounted && (
              <span className="price-discount-del">
                {Number(product.lowestPrice).toLocaleString()}
              </span>
            )}
          </div>

          {product.isDiscounted && (
            <span className="price-discount">
              {product.discountPercent}%
            </span>
          )}
        </div>


        <div className="product-buttom">
          <span className="product-rating">
            <Star size={20} color="#ffca46" strokeWidth={0.5} fill="#ffca46" />
            {product.rating || 4.8}
          </span>
          <CartQuantityControl
            product={product}
          />

          <span className="basket-ico">
            <CartControl product={product} />
          </span>

        </div>

      </div>
    </div>




  );
};

export default ProductCard;
